import * as z from "zod/v4";

const AeoPromptResponseSchema_ = z.object({
  id: z.string(),
  model: z.string(),
  timestamp: z.string(),
  content: z.string(),
});

export const AeoPromptResponseSchema: z.ZodType<AeoPromptResponseSchema> =
  AeoPromptResponseSchema_;
export interface AeoPromptResponseSchema
  extends z.infer<typeof AeoPromptResponseSchema_> {}

export const getAeoPromptResponses = {
  name: "getAeoPromptResponses" as const,
  input: z.object({ promptId: z.string() }),
  output: z.object({ responses: z.array(AeoPromptResponseSchema) }),
};
